/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Alert} from "react-bootstrap";


type DefaultMessageComponentProps = {
    messageText: string,
    messageType?: "info" | "danger" | "warning" | "success"
};


export const DefaultMessageComponent: React.FC<DefaultMessageComponentProps> = ({
    messageText, messageType= "info"
}): JSX.Element => {


    return (
        <Col xs={12} className={"system-message"}>
            <Col xs={12} as={Alert} variant={messageType} className={"system-message-content"}>
                <span>{messageText}</span>
            </Col>
        </Col>
    );

};


export default DefaultMessageComponent;
